import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CrudGenericsService } from '../common/crud-generics';
import { Environment, FunzioniModuli, IFunzioniModuliLng } from '../../models/-index';
import { Observable } from 'rxjs';

@Injectable()
export class FunzioniModuliService extends CrudGenericsService<FunzioniModuli, string> {
  private base: string;
  constructor(protected http: HttpClient, @Inject('ENV') env: Environment) {
    super(http, `${env.apiUrl}/api/FunzioniModuli`);
    this.base = `${env.apiUrl}/api/FunzioniModuli/`;
  }
  GetAll_FunzioniModuliLng(vis_nascosti: boolean = false): Observable<IFunzioniModuliLng[]> {
    const url = this.base + 'GetAll_FunzioniModuliLng?n=' + vis_nascosti;
    return this.http.get<IFunzioniModuliLng[]>(`${url}`);
  }
  GetSingle_FunzioniModuliLng(id: string): Observable<IFunzioniModuliLng> {
    const url = this.base + 'GetSingle_FunzioniModuliLng?id=' + id;

    return this.http.get<IFunzioniModuliLng>(`${url}`);
  }
}
